"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerBankHasFinancialLicenseDetails = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.PartnerBankHasFinancialLicenseDetails = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.partner_bank_has_financial_license_details.label',
    fallbackLabel: 'Provide details regarding your Partner Bank\'s licensing, including the type of licenses they hold, the regulatory authority overseeing them, and license numbers or a link to where we can find information related to your bank\'s licensing',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_entity_answers.licensing', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.mor_entity_answers?.licensing?.valueOf?.() === 'PARTNERED_LICENSED_ENTITY' || payload.mor_entity_answers?.licensing?.valueOf?.() === 'HOLDS_VALID_LICENSE_AND_LICENSED_PARTNER_IN_OTHER_REGIONS')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.mor_entity_answers?.licensing?.valueOf?.() === 'PARTNERED_LICENSED_ENTITY' || payload.mor_entity_answers?.licensing?.valueOf?.() === 'HOLDS_VALID_LICENSE_AND_LICENSED_PARTNER_IN_OTHER_REGIONS')
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
